function setProfileImageIsUploadedState(croppedImage) {
    $('.js-profile-photo').attr('src', croppedImage);
    $('.js-my-account-edit-photo-controls').addClass('uploaded');
    $('.js-profile-photo').addClass('uploaded');
}

function showAlertToastForProfileImageUpload(message) {
    return showToast('toast-image-upload-error', 'alert', message, 5000);
}

function createInputToImageUpload(imageToCrop, cropper, updateCropperCallback) {
    const limit = 2097152; // 2MB in bytes
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
        if (e.target.files[0].size > limit) {
            showAlertToastForProfileImageUpload(
                'The selected image exceeds the maximum file size limit of 2MB. Please choose a smaller file.'
            );
            return;
        }

        handleProfileImageCrop(
            e.target.files[0],
            imageToCrop,
            cropper,
            updateCropperCallback
        );
    };
    input.click();
}

function handleProfileImageCrop(file, imageToCrop, cropper, callback) {
    const reader = new FileReader();

    reader.onload = function (e) {
        imageToCrop.attr('src', e.target.result);
        imageToCrop.show();

        $('.js-mdl-crop').addClass('active');

        if (cropper) {
            cropper.destroy();
            cropper = null;
        }

        if (imageToCrop.data('cropper')) {
            imageToCrop.data('cropper').destroy();
            imageToCrop.removeData('cropper');
        }

        setTimeout(() => {
            imageToCrop.cropper({
                aspectRatio: 1,
                viewMode: 1,
                rotatable: true,
                scalable: true,
                preview: document.querySelector('.js-cropper-preview'),
                ready: function () {
                    const newCropper = imageToCrop.data('cropper');
                    if (callback) {
                        callback(newCropper);
                    }
                },
            });
        }, 100);
    };
    reader.onerror = function (e) {
        showAlertToastForProfileImageUpload('Failed to load the image.');
    };

    reader.readAsDataURL(file);
}

function profileImageCrop() {
    const $currentProfileImage = $('.js-profile-photo');
    const $imageToCrop = $('.js-cropper-image');

    if ($imageToCrop.length === 0) {
        console.warn('$imageToCrop element not found');
        return;
    }

    if (
        $currentProfileImage.attr('src') &&
        $currentProfileImage.attr('src') !== ''
    ) {
        $imageToCrop.cropper({
            aspectRatio: 16 / 9,
        });
    }

    let cropper;

    // Callback function to update cropper instance
    const updateCropper = (newCropper) => {
        cropper = newCropper;
    };

    const cropInitArea = document.querySelector('.js-cropper-init-btn');
    const previewArea = document.querySelector('.js-cropper-preview');

    if (cropInitArea) {
        $(document).on('click', '.js-cropper-init-btn', function () {
            // Check if there is already an image in the profile
            const currentImageSrc = $currentProfileImage.attr('src');

            if (
                currentImageSrc &&
                currentImageSrc !== '' &&
                currentImageSrc !== 'undefined'
            ) {
                // Set the current image in cropper
                $imageToCrop.attr('src', currentImageSrc);
                $imageToCrop.show();
                $('.js-mdl-crop').addClass('active');

                // Clear previous cropper if exists
                if (cropper) {
                    cropper.destroy();
                    cropper = null;
                }

                if ($imageToCrop.data('cropper')) {
                    $imageToCrop.data('cropper').destroy();
                    $imageToCrop.removeData('cropper');
                }

                // Initialize cropper for existing image
                setTimeout(() => {
                    $imageToCrop.cropper({
                        aspectRatio: 1,
                        viewMode: 1,
                        rotatable: true,
                        scalable: true,
                        preview: previewArea,
                        ready: function (e) {
                            cropper = $imageToCrop.data('cropper');
                        },
                    });
                }, 100);
            } else {
                // If no image exists - start uploading a new file
                createInputToImageUpload($imageToCrop, cropper, updateCropper);
            }
        });
    } else {
        console.warn('Crop init area element not found on the page');
    }

    const warningMessageForCropperControls = () =>
        console.warn('Cropper not initialized or not ready');

    // Handler for the "Upload another" button in the modal
    $('.js-cropper-init-btn').on('click', function (e) {
        if ($(this).closest('.js-mdl-crop').length > 0) {
            e.stopPropagation();

            createInputToImageUpload($imageToCrop, cropper, updateCropper);
        }
    });

    $('.js-cropper-btn-crop').on('click', () => {
        if (cropper && typeof cropper.getCroppedCanvas === 'function') {
            const canvas = cropper.getCroppedCanvas();
            if (canvas) {
                const croppedImage = canvas.toDataURL('image/jpeg');
                setProfileImageIsUploadedState(croppedImage);
                $('.js-mdl-crop').removeClass('active');
            }
        } else {
            warningMessageForCropperControls();
        }
    });

    $('.js-cropper-btn-rotate-left').on('click', () => {
        if (cropper && typeof cropper.rotate === 'function') {
            cropper.rotate(-45);
        } else {
            warningMessageForCropperControls();
        }
    });

    $('.js-cropper-btn-rotate-right').on('click', () => {
        if (cropper && typeof cropper.rotate === 'function') {
            cropper.rotate(45);
        } else {
            warningMessageForCropperControls();
        }
    });

    $('.js-cropper-btn-zoom-in').on('click', () => {
        if (cropper && typeof cropper.zoom === 'function') {
            cropper.zoom(0.1);
        } else {
            warningMessageForCropperControls();
        }
    });

    $('.js-cropper-btn-zoom-out').on('click', () => {
        if (cropper && typeof cropper.zoom === 'function') {
            cropper.zoom(-0.1);
        } else {
            warningMessageForCropperControls();
        }
    });
}

runIfElementExist(profileImageCrop, '.js-cropper-init-btn');
